module.exports = "/_next/static/resources/background-1-6f98ed745ed3f7904dffd47fbafe1469.jpg";